import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlannerAppointmentsRejected } from '~constants/api';

import { Paginated, Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { Appointment } from '~weekly-planner/lib/common';

import { typePrefix as prefix } from '~weekly-planner/actions/appointments';

export const typePrefix = `${prefix}-rejected`;

export const rejectedApi = createApi({
  reducerPath: 'weeklyPlannerRejectedApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlannerAppointmentsRejected }),
  tagTypes: ['rejected'],
  endpoints: (builder) => ({
    getRejected: builder.query<Paginated<Appointment>, Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'rejected', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Paginated<Appointment>>(payload),
    }),
  }),
});

export const { useGetRejectedQuery } = rejectedApi;
